import { Theme } from '@cvent/carina/components/ThemeProvider';
import darkFormulaCarina from '@cvent/carina/utils/themeBuilder/carinaDarkFormula';
import { generateAllBackgroundRamps } from '@cvent/carina/utils/tokens/configurations';
import { FinalizedColorPalette } from '@cvent/carina/types/theme';

/** Basic dark formula with added backgroundColors */
export default function darkFormula(palette: FinalizedColorPalette): Theme {
  return generateAllBackgroundRamps(darkFormulaCarina(palette));
}
